import { workspaceIconPackA } from './workspaceIconPackA'
import { workspaceIconPackB } from './workspaceIconPackB'
import { workspaceIconPackC } from './workspaceIconPackC'
import { workspaceIconPackD } from './workspaceIconPackD'
import { workspaceIconPackE } from './workspaceIconPackE'

const ICONS = {
  ...workspaceIconPackA,
  ...workspaceIconPackB,
  ...workspaceIconPackC,
  ...workspaceIconPackD,
  ...workspaceIconPackE,
}

export function workspaceIconComponent(iconId, size = 16) {
  const pack = ICONS[iconId] ?? ICONS.briefcase
  return pack[size] ?? pack[16]
}
